import i18next from '../../config/i18next';

i18next.addResources('es', 'Login', {
  LogIn: 'Iniciar sesión',
  User: 'Usuario',
  Password: 'Contraseña',
  country: 'País',
  KeepLog: 'Mantenerme logueado en esta máquina',
  Forgot: '¿Olvidó su contraseña?',
  Invalid: 'Los datos ingresados son incorrectos. Intente nuevamente.',
});

export default i18next;
